<section class="my-registration-detail">
   <div class="back-link common-label">
            <a href="javascript:void(0)" (click)="backToHome()">
            <mat-icon class="back-icon">chevron_left</mat-icon>Quay lại trang chủ</a>
  </div>
  
    <p class="text-title p-title">Chi tiết đăng ký</p> 
 <div class="common-label" >
    <mat-card class="registration-card">
    <p class="text-title"><strong>{{ myRegistrationDetail?.form?.name }}</strong></p>
    <p><strong>Mô tả:</strong> {{ myRegistrationDetail?.form?.description }}</p>
    <p><strong>Loại:</strong> {{ myRegistrationDetail?.form?.category }}</p>
    <p><strong>Thời gian đăng ký:</strong> 
      {{ myRegistrationDetail?.form?.startDate | date: 'dd/MM/yyyy' }} - 
      {{ myRegistrationDetail?.form?.endDate | date: 'dd/MM/yyyy' }}
    </p>

    <div class="user-info">
      <p><strong>Phật tử:</strong> {{ myRegistrationDetail?.user?.name }} ({{ myRegistrationDetail?.user?.username }})</p>
      <p *ngIf="myRegistrationDetail?.registrant"><strong>Người đăng ký:</strong> {{ myRegistrationDetail?.registrant?.name }}</p>
      <p><strong>Mã đạo tràng:</strong> {{ myRegistrationDetail?.ma_dao_trang || 'Không có' }}</p>
    </div>

    <mat-divider class="my-4"></mat-divider>

    <p class="text-title"> <strong>Thông tin chi tiết đã đăng ký </strong></p>
    <div class="field-value "  class="input-label" *ngFor="let field of myRegistrationDetail?.form?.fields">
      <p>
        <strong>{{ field.label }}:</strong>
        {{
          getAnswerForField(field.id, myRegistrationDetail?.values) || 'Chưa có dữ liệu'
        }}
      </p>
    </div>
  </mat-card>
</div>
</section>

    
     
    
  
